/**
 * exp/contact-us — form popup modal (shared contact-modal behaviour).
 */
function strlInitContactUsModals() {
	if ( window.__strlContactsModalsReady__ ) {
		return;
	}
	window.__strlContactsModalsReady__ = true;

	let activeModal = null;

	const openModal = ( modalId ) => {
		if ( ! modalId ) {
			return;
		}

		const modal = document.getElementById( modalId );
		if ( ! modal || ! modal.matches( '[data-contact-modal]' ) ) {
			return;
		}

		modal.removeAttribute( 'hidden' );
		modal.setAttribute( 'aria-hidden', 'false' );
		document.documentElement.classList.add( 'overflow-hidden' );
		document.body.classList.add( 'overflow-hidden' );
		activeModal = modal;
	};

	const closeModal = ( modal ) => {
		if ( ! modal ) {
			return;
		}

		modal.setAttribute( 'aria-hidden', 'true' );
		modal.setAttribute( 'hidden', '' );
		document.documentElement.classList.remove( 'overflow-hidden' );
		document.body.classList.remove( 'overflow-hidden' );
		if ( activeModal === modal ) {
			activeModal = null;
		}
	};

	document.addEventListener( 'click', ( event ) => {
		const trigger = event.target.closest( '[data-contact-modal-target]' );
		if ( trigger ) {
			event.preventDefault();
			openModal( trigger.getAttribute( 'data-contact-modal-target' ) );
			return;
		}

		const closeTrigger = event.target.closest( '[data-contact-modal-close]' );
		if ( closeTrigger ) {
			event.preventDefault();
			closeModal( closeTrigger.closest( '[data-contact-modal]' ) );
			return;
		}

		const modal = event.target.closest( '[data-contact-modal]' );
		if ( modal && ! event.target.closest( '[data-contact-modal-panel]' ) ) {
			closeModal( modal );
		}
	} );

	document.addEventListener( 'keydown', ( event ) => {
		if ( 'Escape' === event.key && activeModal ) {
			closeModal( activeModal );
		}
	} );
}

strlInitContactUsModals();
